/**
 * @ngDoc: btsCoupling
 * @description: 'EXPERIMENTAL Directive To handle hooking up AEM to NG through attributes and content.'
 */
module.exports = function (app) {
    app.directive('btsCoupling', ['ViewRulesEngineFactory', 'session', function (ViewRulesEngineFactory, session) {
        return {
            priority: 10,
            require: '',
            link: function postLink(scope, iElement, iAttrs, controller) {
                var btsCoupling = iAttrs.btsCoupling = function () {
                    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
                    if (base64regex.test(iAttrs.btsCoupling)) {
                        return JSON.parse(atob(iAttrs.btsCoupling));
                    }
                    return JSON.parse(iAttrs.btsCoupling);
                }();
                if (btsCoupling.setOnScope) {
                    angular.extend(scope, btsCoupling.setOnScope);
                }
                if (btsCoupling.viewQualifiers) {
                    var viewRulesEngine = ViewRulesEngineFactory(session.data, btsCoupling.viewQualifiers);
                    var displayElement = {
                        displayElement: scope.displayElement || {},
                        displaySubMenu: {}
                    };
                    displayElement.displayElement[iAttrs.identifier] = viewRulesEngine.execute();
                    angular.extend(scope, displayElement, {tabIdentifier: iAttrs.identifier});
                }
                scope.dataMaps = btsCoupling.dataMaps;
            }
        };
    }]);
};